import { render, staticRenderFns } from "./semiRank.vue?vue&type=template&id=702e97bc&scoped=true"
import script from "./semiRank.vue?vue&type=script&lang=js"
export * from "./semiRank.vue?vue&type=script&lang=js"
import style0 from "./semiRank.vue?vue&type=style&index=0&id=702e97bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702e97bc",
  null
  
)

export default component.exports